import React from "react"
import { TailSpin } from "react-loader-spinner"
import "./Loader.css"

export default function Loader() {
    return (
        <div className="loader-area">
            <TailSpin
                visible={true}
                height="80"
                width="80"
                color="var(--app-theme-color)"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
    )
}
